import { LuCalendarPlus } from 'react-icons/lu';
import { Link, NavLink } from 'react-router-dom';
import { Button } from 'reactstrap';

import { ROLE_LABELS } from 'src/features/auth/roles';
import { useSession } from 'src/features/auth/useAuth';
import Avatar from 'src/shared/components/ui/Avatar';
import Wordmark from 'src/shared/components/ui/Wordmark';
import type { NavItem } from './navTypes';

interface SideNavProps {
  items: NavItem[];
  onNewAppointment: () => void;
  onOpenAccount: () => void;
}

/**
 * Tablet and desktop navigation: an icon rail from 768px, a full sidebar from
 * 1200px. The same markup; the stylesheet decides how much of it shows.
 */
export default function SideNav({ items, onNewAppointment, onOpenAccount }: SideNavProps) {
  const user = useSession();
  const name = user ? user.fullName || user.email : '';

  return (
    <nav className="v-sidenav" aria-label="Navegación principal">
      <Link to="/" className="v-sidenav__brand" aria-label="Grazia, ir al inicio">
        <span className="v-sidenav__wide">
          <Wordmark />
        </span>
        <span className="v-sidenav__narrow">
          <Wordmark compact />
        </span>
      </Link>

      <Button
        color="primary"
        className="v-sidenav__create"
        onClick={onNewAppointment}
        aria-label="Nueva cita"
      >
        <LuCalendarPlus aria-hidden="true" />
        <span className="v-sidenav__wide">Nueva cita</span>
      </Button>

      <ul className="v-sidenav__nav">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink to={item.to} end={item.to === '/'} className="v-sidenav__link">
              <item.icon aria-hidden="true" />
              <span>{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      {user && (
        <div className="v-sidenav__footer">
          <button
            type="button"
            className="v-account"
            onClick={onOpenAccount}
            aria-label="Tu cuenta"
          >
            <Avatar name={name} size={36} variant="ink" />
            <span className="v-account__text">
              <span className="v-account__name">{name}</span>
              <span className="v-account__role">{ROLE_LABELS[user.role] ?? user.role}</span>
            </span>
          </button>
        </div>
      )}
    </nav>
  );
}
